module.exports = __webpack_public_path__ + "static/media/eclos-brand-background-1.cd2e97e0.png";